import { resellerLicense } from "../../constants/actionTypes";

const INITIAL_STATE = {
  resellerLicenseList: {},
  resellerLicenseItem: {},
  resellerLicenseClientView: {},
  errorData: {},
  editLicense: {},
  loader: false,
  licenseSummary: "",
  licenseSummaryError: "",
  successDeleteLicense: "",
};

const resellerLicenseReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case resellerLicense?.GET_RESELLERLICENSE_LIST:
      return {
        ...state,
        loader: true,
      };
    case resellerLicense?.SUCCESS_GET_RESELLERLICENSE_LIST:
      return {
        ...state,
        resellerLicenseList: action?.payload,
        loader: false,
      };

    case resellerLicense?.ERROR_GET_RESELLERLICENSE_LIST:
      return {
        ...state,
        resellerLicenseError: action?.payload,
        loader: false,
      };
    case resellerLicense?.GET_RESELLERLICENSE_ITEM:
      return {
        ...state,
        loader: true,
      };
    case resellerLicense?.SUCCESS_GET_RESELLERLICENSE_ITEM:
      return {
        ...state,
        resellerLicenseItem: action?.payload,
        loader: false,
      };
    case resellerLicense?.ERROR_GET_RESELLERLICENSE_ITEM:
      return {
        ...state,
        resellerLicenseError: action?.payload,
        loader: false,
      };
    case resellerLicense.LICENSE_EDIT_SUCCESS:
      return {
        ...state,
        editLicense: {
          ...action.payload,
        },
      };
    case resellerLicense?.SUCCESS_SET_LICENSE:
    case resellerLicense?.SUCCESS_UPDATE_LICENSE:
      return {
        ...state,
        resellerLicenseItem: action?.payload,
      };

    case resellerLicense?.SUCCESS_DELETE_LICENSE:
      return {
        ...state,
        successDeleteLicense: action?.payload,
      };

    case resellerLicense.ERROR_SET_LICENSE:
      return {
        ...state,
        resellerLicenseSETError: action?.payload,
      };
    case resellerLicense.GET_LICENSE_SUMMARY:
      return {
        ...state,
        licenseSummaryData: action?.payload,
      };
    case resellerLicense.SET_LICENSE_SUMMARY:
      return {
        ...state,
        licenseSummaryData: action?.payload,
      };
    case resellerLicense.ERROR_LICENSE_SUMMARY:
      return {
        ...state,
        licenseSummaryError: action?.payload,
      };
    case resellerLicense.SET_LICENSE_LIST_DATA:
      return {
        ...state,
        lic: {
          ...action?.payload,
        },
      };

    case resellerLicense?.CLEAR_LICENSE_ITEM:
      return {
        ...state,
        resellerLicenseItem: "",
      };

    case resellerLicense?.GET_RESELLERLICENSE_CUSTOMER_VIEW:
      return {
        ...state,
        loader: true,
      };
    case resellerLicense?.SUCCESS_GET_RESELLERLICENSE_CUSTOMER_VIEW:
      return {
        ...state,
        resellerLicenseClientView: action?.payload,
        loader: false,
      };

      case resellerLicense?.ERROR_GET_RESELLERLICENSE_CUSTOMER_VIEW:
        return {
          ...state,
          resellerLicenseError: action?.payload,
          loader: false,
        };
    default:
      return state;
  }
};

export default resellerLicenseReducer;
